"use strict";const o=require("styled-components").css`
    &.DXCheckbox {
        position: relative;

        input {
            position: absolute;
            opacity: 0;
            visibility: hidden;
        }

        input:focus,
        input:active {
            & + label .DXCheckbox-icon-default {
                border-color: ${({theme:o,color:e})=>e||o.colors.primary.default};
            }
            & + label .DXCheckbox-checked-icon-default {
                background-color: ${({theme:o,color:e})=>e||o.colors.primary.default};
                border-color: ${({theme:o,color:e})=>e||o.colors.primary.default};
            }
        }

        input:disabled {
            & + label .DXCheckbox-icon-default,
            &:hover + label .DXCheckbox-icon-default,
            &:focus + label .DXCheckbox-icon-default,
            &:hover:focus + label .DXCheckbox-icon-default {
                background-color: ${({theme:o})=>o.colors.grey[500]};
                border-color: ${({theme:o})=>o.colors.grey[500]};
            }

            & + label {
                cursor: not-allowed;
                color: ${({theme:o})=>o.colors.grey[500]};
            }
        }

        label {
            align-items: center;
            color: rgb(78, 82, 85);
            cursor: pointer;
            display: flex;
            flex-direction: row;
            font-size: ${({compact:o})=>o?"12px":"14px"};
            font-family: 'source-sans-pro', sans-serif;
            .DXTypography {
                margin-left: 10px;
            }
        }

        label .DXCheckbox-icon-default {
            background: white no-repeat center;
            background-size: 70%;
            border: #777b7e 1px solid;
            border-radius: 2px;
            font-size: 0;
            outline: 0;

            min-height: ${({compact:o})=>o?"12px":"20px"};
            min-width: ${({compact:o})=>o?"12px":"20px"};
        }
        .DXCheckbox-checked-icon,
        .DXCheckbox-icon {
            font-size: 0;
            /* outline: 0; */
            min-height: ${({compact:o})=>o?"12px":"20px"};
            min-width: ${({compact:o})=>o?"12px":"20px"};
        }

        .DXCheckbox-checked-icon-default {
            background: white no-repeat center;
            background-size: 70%;
            border: #777b7e 1px solid;
            border-radius: 2px;
            background-color: ${({theme:o,color:e})=>e||o.colors.primary.default};
            border-color: ${({theme:o,color:e})=>e||o.colors.primary.default};
            display: flex;
            align-items: center;
            justify-content: center;
            outline: 0;
            svg {
                width: 80%;
            }
        }

        &:hover {
            .DXCheckbox-icon-default {
                border-color: ${({theme:o,color:e})=>e||o.colors.primary.default};
            }
            .DXCheckbox-checked-icon-default {
                background-color: ${({theme:o,color:e})=>e||o.colors.primary.default};
                border-color: ${({theme:o,color:e})=>e||o.colors.primary.default};
            }
        }

        input:disabled {
            & + .DXCheckbox-icon-default,
            &:hover + .DXCheckbox-icon-default,
            &:focus + .DXCheckbox-icon-default,
            &:hover:focus + .DXCheckbox-icon-default {
                background-color: ${({theme:o})=>o.colors.grey[500]};
                border-color: ${({theme:o})=>o.colors.grey[500]};
            }

            & + label {
                cursor: not-allowed;
                color: ${({theme:o})=>o.colors.grey[500]};
            }
        }
    }
`;module.exports=o;
//# sourceMappingURL=styles.js.map
